import React, { useState } from "react";
import {
  RootContainer,
  ArrowIconWrapper,
  ContentContainer,
  Form,
  NavContainer,
  BackIcon,
  Title
} from "./CreatePassword.style";
import { Button } from "antd";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { api } from "@api";
import { REGISTER_MODE_SK, EMAIL_REQUIRED_SK } from "@constants";
import { useDispatch, useSelector } from "react-redux";
import { openAlert } from "@redux/app/appSlice";
import { Alert } from "@components";
import { useTranslation } from "react-i18next";
import { InputPassword } from "@components";
import { getFingerprintData, localStorage } from '@utils';
import { saveToken, saveUser } from "@redux/auth/authSlice";

const CreatePassword = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const isLoggedIn = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(false);

  const onFinish = ({ password, confirm_password }) => {
    if (!loading) {
      if (password !== confirm_password) {
        showAlert({
          message: t("auth.createPasswordPinNotMatch"),
          isError: true,
        });
        return;
      }
      setLoading(true);
      getFingerprintData()
        .then(device_info => {
          const payload = {
            device_info,
            password,
            ...state,
          };
          api
            .register(payload)
            .then((response) => {
              setLoading(false);
              showAlert({
                message: response?.message,
                successCallback: () => successCallback(payload, response),
              });
            })
            .catch((errorMsg) => {
              setLoading(false);
              showAlert({
                message: errorMsg === EMAIL_REQUIRED_SK ? t("auth.emailRequiredMessage") : errorMsg,
                isError: true,
                successCallback: errorMsg === EMAIL_REQUIRED_SK ? () => goToEmail(payload) : () => { },
              });
            });
        })
        .catch(() => { });
    }
  };

  const goToEmail = (data) => {
    navigate(`/${PUBLIC_ROUTE.EMAIL_REGISTER}`, {
      state: data,
    });
  }

  const successCallback = (data, response) => {
    if (data.google_user_id) {
      handleRegisterSuccess(response);
      return;
    }
    navigate(`/${PUBLIC_ROUTE.OTP_VERIFY}/${REGISTER_MODE_SK}`, {
      state: data,
    });
  };

  const handleRegisterSuccess = (response) => {
    if (response) {
      const { token, ...user } = response.user || {};
      // save token and user to redux
      dispatch(saveToken(token));
      dispatch(saveUser(user));

      // save token and user to localstorage
      localStorage.setToken(token);
      localStorage.setUser(user);

      // set token to request obj
      api.setSessionToken(token);
    }
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  const goBack = () => {
    navigate(-1);
  };

  if (!state) {
    return <Navigate to={`/${PUBLIC_ROUTE.LOGIN}`} />;
  }

  if (isLoggedIn) {
    return <Navigate to={`/${PUBLIC_ROUTE.HOME}`} />;
  }

  return (
    <>
      <RootContainer>
        <NavContainer>
          <ArrowIconWrapper onClick={goBack}>
            <BackIcon />
          </ArrowIconWrapper>
        </NavContainer>

        <ContentContainer>
          <Title> {t("auth.createPasswordTitle")} </Title>
          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item
              name="password"
              label={t("auth.createPasswordNewPin")}
              rules={[
                {
                  required: true,
                  message: "",
                },
                {
                  pattern: /^[0-9]{6}$/,
                  message: t("auth.createPasswordValidate"),
                },
              ]}
            >
              <InputPassword autoFocus placeholder={t("auth.createPasswordPlaceholder")} />
            </Form.Item>
            <Form.Item
              name="confirm_password"
              label={t("auth.createPasswordConfirmPin")}
              rules={[
                {
                  required: true,
                  message: "",
                },
                {
                  pattern: /^[0-9]{6}$/,
                  message: t("auth.createPasswordValidate"),
                },
              ]}
            >
              <InputPassword placeholder={t("auth.createPasswordPlaceholder")} />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                loading={loading}
              >
                {t("common.continue")}
              </Button>
            </Form.Item>
          </Form>
        </ContentContainer>
      </RootContainer>
      <Alert />
    </>
  );
};

export default CreatePassword;
